module.exports = __webpack_public_path__ + "img/17.5025f884.jpg";